var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0012 17.0803C14.1259 17.0803 15.8483 15.3579 15.8483 13.2332C15.8483 11.1084 14.1259 9.38599 12.0012 9.38599C9.87643 9.38599 8.15399 11.1084 8.15399 13.2332C8.15399 15.3579 9.87643 17.0803 12.0012 17.0803Z",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1981 20.7457C12.0692 20.7457 11.9394 20.7457 11.8134 20.7457L8.73087 22.4664C7.53087 22.0627 6.41783 21.4362 5.4502 20.6198L5.43866 17.1573C5.37037 17.0496 5.30593 16.9409 5.2463 16.8293L2.18108 15.0837C1.93964 13.8625 1.93964 12.6058 2.18108 11.3846L5.24342 9.64379C5.30593 9.53318 5.37037 9.42354 5.43578 9.31582L5.45116 5.85337C6.41792 5.03454 7.53067 4.40573 8.73087 4L11.8086 5.72064C11.9375 5.72064 12.0673 5.72064 12.1933 5.72064L15.2711 4C16.4711 4.40365 17.5841 5.03016 18.5517 5.84664L18.5633 9.30909C18.6315 9.41681 18.696 9.52549 18.7556 9.63706L21.8189 11.3817C22.0604 12.6029 22.0604 13.8596 21.8189 15.0808L18.7566 16.8216C18.6941 16.9322 18.6296 17.0419 18.5642 17.1496L18.5488 20.6121C17.5827 21.431 16.4706 22.0602 15.2711 22.4664L12.1981 20.7457Z",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsPurple);
export default __webpack_public_path__ + "static/media/settings_purple.25a52a9d325fa4e71b8d304e137530d5.svg";
export { ForwardRef as ReactComponent };